import * as z from 'zod';

export const mutualFundFormSchema = z.object({
  // Base investment fields
  fund_name: z.string().min(1, 'Fund name is required').max(100),
  fund_manager: z.string().min(1, 'Fund manager is required').max(100),
  account_number: z.string().min(1, 'Account number is required').max(50),
  currency: z.string().min(1, 'Currency is required'),
  interest_rate: z.number().min(0).max(100),
  starting_amount: z.number().positive('Starting amount must be greater than 0'),
  notes: z.string().max(500).optional(),
  description: z.string().max(500).optional(),

  // Mutual-fund-specific fields
  fund_category: z.enum(['equity', 'debt', 'hybrid', 'index', 'sectoral'], {
    required_error: 'Fund category is required',
  }),
  risk_rating: z.enum(['low', 'moderate', 'high'], {
    required_error: 'Risk rating is required',
  }),
  benchmark_index: z.string().max(100).optional(),
  isin: z.string().max(12).regex(/^[A-Z]{2}[A-Z0-9]{9}[0-9]$/, 'ISIN must be 12 characters (e.g. US0378331005)').optional().or(z.literal('')),
  units_held: z.number().min(0, 'Units held cannot be negative'),
  unit_cost_basis: z.number().min(0, 'Cost basis cannot be negative'),
  current_nav: z.number().min(0, 'NAV cannot be negative'),
  nav_date: z.string().optional(),
});

export type MutualFundFormSchema = z.infer<typeof mutualFundFormSchema>;
